import React from 'react';
import { useNavigate } from 'react-router-dom';

function Navbar({ user: userProp }) {
  const navigate = useNavigate();

  // Fall back to localStorage so callers don't need to pass the prop
  const user = userProp ?? (() => {
    try { return JSON.parse(localStorage.getItem('user') || 'null'); }
    catch { return null; }
  })();

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };

  return (
    <nav className="a-navbar">
      <div className="a-navbar__brand">
        <span className="a-navbar__brand-scala">SCALA</span>
        <span className="a-navbar__brand-app">Performer</span>
      </div>
      {user?.email && (
        <div className="a-navbar__right">
          <span>{user.email}</span>
          <button className="a-navbar__signout" onClick={handleLogout}>
            Sign out
          </button>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
